import { useAccount } from 'components/account/AccountProvider';
import { useTranslation } from 'components/translation/TranslationProvider';
/**
 * @function getConfigurationFieldValue
 * @since 1.0.0
 */
export function getConfigurationFieldValue(configurationFields, tag, mediaUrl = false) {
    var _a;
    const account = useAccount();
    const { language } = useTranslation();
    let value;
    const configField = configurationFields === null || configurationFields === void 0 ? void 0 : configurationFields.find((conf) => conf.fieldKey === tag);
    if (configField && configField.value) {
        value = JSON.parse(configField === null || configField === void 0 ? void 0 : configField.value).value;
    }
    if (value && value.value) {
        let languageIndex = account.languages.findIndex((lang) => lang.code === language);
        if (languageIndex === -1) {
            languageIndex = 0;
        }
        return value.value[languageIndex].translations;
    }
    if ((configField === null || configField === void 0 ? void 0 : configField.type) === 'MEDIA' && mediaUrl) {
        return (_a = configField.media) === null || _a === void 0 ? void 0 : _a.url;
    }
    return value;
}
